"use strict";
/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserRole = void 0;
/** The institution level roles the user has */
var UserRole;
(function (UserRole) {
    UserRole["GENERAL"] = "general";
    UserRole["ADMIN"] = "admin";
    UserRole["STAFF"] = "staff";
})(UserRole = exports.UserRole || (exports.UserRole = {}));
